'use strict';

import 'document-register-element';
import {isTouch} from '../utils';


export class ClapView extends HTMLAnchorElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._inner = this.innerHTML;
    this._mask = document.createElement('mask-light');
    this._mask.innerHTML = this._inner;
    // clearElements(this);
    this.appendChild(this._mask);

    this._isHover = false;
    this._timer = null;
  }
  connectedCallback() {
    if (isTouch()) return;

    const count = Math.min(Math.floor(this.offsetWidth / 150), 4);

    this._claps = [];

    for (let i = 0; count + 1 > i; i++) {
      const clap = document.createElement('span');
      clap.classList.add('clap-item');
      clap.style.left = `${(i / count) * 100}%`;
      clap.style.animationDelay = `${Math.random()}s`;
      this._claps.push(clap);
      this.appendChild(clap);
    }

    this.addEventListener('mouseenter', () => {
      if (this._isHover) return;
      this._isHover = true;

      this._claps.forEach(el => {
        el.style.margin = `${(Math.random() - 0.5) * 70 - 40}px 0 0 ${(Math.random() - 0.5) * 20 - 40}px`;
      })
    });
    this.addEventListener('mouseleave', () => setTimeout(() => this._isHover = false, 301));
  }
}


window.customElements.define('clap-view', ClapView, {extends: 'a'});